import { Component } from '@angular/core';

@Component({
	selector: 'eif-documents-upload-confirming-instructions',
	templateUrl: './documents-upload-instructions.component.html',
	styleUrls: ['./documents-upload-instructions.component.scss'],
	standalone: false,
})
export class DocumentsUploadConfirmingInstructionsComponent {}
